import { render, staticRenderFns } from "./TransferInspectModal.vue?vue&type=template&id=05845fd0&scoped=true&"
import script from "./TransferInspectModal.vue?vue&type=script&lang=ts&"
export * from "./TransferInspectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05845fd0",
  null
  
)

export default component.exports